import parsePhoneNumber from 'libphonenumber-js';
import Vue from 'vue';
import OrderStatus from '@/manage/enums/customer-report/order-status.enum';
import DateService from '@/_shared/services/date.service';

export default class CustomerDetailsMixin extends Vue {
  formatDate(date: string): string {
    if (!date) return '-';
    return DateService.getLocaleFormattedDate(date);
  }

  formatPhoneNumber(item: any): string {
    const phoneNumber = parsePhoneNumber(item.phone, item.countryCode);
    if (phoneNumber) {
      return phoneNumber.isValid() ? phoneNumber.formatNational() : item.phone;
    }
    return item.phone || '-';
  }

  mapTrackStatus(status: OrderStatus = OrderStatus.UNSPECIFIED): string {
    const translationByStatus = {
      [OrderStatus.UNSPECIFIED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.UNSPECIFIED'),
      [OrderStatus.ENTERED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.ENTERED'),
      [OrderStatus.POSTED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.POSTED'),
      [OrderStatus.SHIPPED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.SHIPPED'),
      [OrderStatus.PARTIAL_BACK_ORDER]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.PARTIAL_BACK_ORDER'),
      [OrderStatus.BACK_ORDER]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.BACK_ORDER'),
      [OrderStatus.VOID]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.VOID'),
      [OrderStatus.CANCELLED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.CANCELLED'),
      [OrderStatus.IMPORTED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.IMPORTED'),
      [OrderStatus.VOID_RETRY]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.VOID_RETRY'),
      [OrderStatus.VOID_RETRY_X]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.VOID_RETRY_X'),
      [OrderStatus.COD_ENTERED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.COD_ENTERED'),
      [OrderStatus.COD_POSTED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.COD_POSTED'),
      [OrderStatus.COD_DELIVERED]: this.$t('CUSTOMER_REPORT.ORDER_ITEM.STATUS.COD_DELIVERED'),
    };
    return translationByStatus[status].toString();
  }
}
